export { default } from "./EliminaIngredientes";
